import type { RequirementStatus } from '../api/requirements';
import { railStepsFor, nextActionHint } from '../lib/statusMapping';

type Props = {
  readonly status: RequirementStatus;
};

export function ProgressRail({ status }: Props) {
  const steps = railStepsFor(status);
  const nextText = nextActionHint(status);
  const isFinal = status === 'RELEASED' || status === 'ARCHIVED';

  return (
    <div className="progress-rail">
      <div className="rail-top">
        <div className="rail-phase">Workflow</div>
        {nextText && (
          <div className="rail-next">
            {!isFinal && <span className="lime-dot" />}
            {nextText}
          </div>
        )}
      </div>
      <div className="rail-track">
        {steps.map((s) => (
          <div key={s.key} className={'rail-step ' + (s.state === 'idle' ? '' : s.state)}>
            <div className="rail-dot" />
            <div className="rail-label">{s.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
